export default __webpack_public_path__ + "static/media/dai.7dc841cd.svg";